import { useLang } from "../context/LangContext";

export function LanguageSwitcher({ tone = "brown" }) {
  const { lang, setLang, langs } = useLang();
  const base =
    tone === "cream"
      ? "text-brand-cream/70 hover:text-brand-cream"
      : "text-brand-tan hover:text-brand-brown";
  const active = tone === "cream" ? "text-brand-cream" : "text-brand-brown";
  return (
    <div
      className="inline-flex items-center gap-2 text-[11px] tracking-[0.25em] font-bold uppercase"
      data-testid="lang-switcher"
    >
      {langs.map((l, i) => (
        <span key={l.code} className="flex items-center gap-2">
          <button
            onClick={() => setLang(l.code)}
            className={`transition-colors ${lang === l.code ? active : base}`}
            data-testid={`lang-${l.code}`}
            type="button"
          >
            {l.label}
          </button>
          {i < langs.length - 1 && (
            <span className={tone === "cream" ? "text-brand-cream/40" : "text-brand-tan/50"}>
              ·
            </span>
          )}
        </span>
      ))}
    </div>
  );
}

export default LanguageSwitcher;
